import { css } from 'linaria';

export const mediaBlockSlide = css`
  height: 556px;
  position: relative;
  
  @media (--only-tablet) {
    margin-right: 24px;
  }

  @media (--only-mobile) {
    height: 460px;
     margin-right: 12px;
  }
`;

export const mediaBlockCardWrapper = css`
  width: 100%;
  height: 100%;
`;

export const mediaBlockImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-xl);
  object-fit: cover;
`;

export const mediaBlockImageInfo = css`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  position: absolute;
  bottom: 0;
  padding: 32px;

  @media (--from-tablet) {
    p {
      white-space: break-spaces;
    }
  }
`;

export const mediaBlockImageInfoTitle = css`
  @media (--to-desktop) {
    font-size: 21px;
    line-height: 28px;
  }
`;

export const mediaBlockImageInfoText = css`
  &&& {
    @media (--only-largeDesktop) {
      width: 814px;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
    }

    @media (--to-desktop) {
      font-size: 17px;
      line-height: 24px;
    }
  }
`;
